module.exports = __webpack_public_path__ + "static/img/cskype-kaka.721443d3.svg";